// src/components/AskGenie/SourceViewer.jsx
import React from 'react';
import { FileText, X } from 'lucide-react';

function SourceViewer({ selectedCitation, setSelectedCitation }) {
  return (
    <div
      className="flex-grow-1 col-3 border-start bg-light p-3"
      style={{
        maxWidth: '250px',
        position: 'sticky',
        top: '0',
        height: '100vh',
        overflowY: 'auto',
      }}
    >
      {selectedCitation ? (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fw-semibold">Source Content</h6>
            <button
              className="btn btn-sm btn-link"
              onClick={() => setSelectedCitation(null)}
            >
              <X size={16} />
            </button>
          </div>
          <div className="bg-white rounded p-3">
            <div className="mb-2">
              <div>{selectedCitation.document}</div>
              {selectedCitation.page && selectedCitation.section && (
                <div className="small text-muted">
                  Page {selectedCitation.page}, {selectedCitation.section}
                </div>
              )}
            </div>
            {selectedCitation.content && (
              <div className="border-start border-primary border-3 ps-2">
                {selectedCitation.content}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex align-items-center justify-content-center text-center text-muted p-3">
          <FileText
            size={24}
            className="mb-2"
            style={{ display: 'inline-block' }}
          />
          <p className="small">Click on a citation to view its content</p>
        </div>
      )}
    </div>
  );
}

export default SourceViewer;
